import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { MonthlyBudgetResetType } from '../../../core/types/enums';
import { Resident } from '../../models/resident.model';
import { Router } from '@angular/router';
import { ResidentsService } from '../../../core/services/residents';
import { CartService } from '../../../core/services/cart/cart.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-resident-budget',
  templateUrl: './resident-budget.component.html',
  styleUrls: ['./resident-budget.component.scss'],
  imports: [CommonModule, MatIconModule, MatTooltipModule],
})
export class ResidentBudgetComponent implements OnInit, OnChanges {
  @Input() resident: Resident | null = null;
  @Input() theme: 'light' | 'dark' = 'light';
  @Input() showAddBudget = true;
  residentTotal: number = 0;
  constructor(
    private router: Router,
    private residentsService: ResidentsService,
    private cartService: CartService
  ) {}

  ngOnInit(): void {
    this.cartService.getAllCarts().subscribe(() => {
      this.residentTotal =
        this.cartService.cart.getResidentCart(this.resident?.id)?.total || 0;
    });
  }

  ngOnChanges(): void {
    this.residentTotal =
      this.cartService.cart.getResidentCart(this.resident?.id)?.total || 0;
  }

  calculateResidentBudget(residentId: number) {
    if (!this.resident) {
      return null;
    }
    let residentsOrderSum = 0;
    if (
      MonthlyBudgetResetType.BeginningOfMonth ===
      this.resident.monthlyBudgetResetType
    ) {
      residentsOrderSum =
        this.residentsService.residentsOrdersSum['beginningOfMonth'][
          residentId
        ] ?? 0;
    } else if (
      MonthlyBudgetResetType.MiddleOfMonth ===
      this.resident.monthlyBudgetResetType
    ) {
      residentsOrderSum =
        this.residentsService.residentsOrdersSum['middleOfMonth'][residentId] ??
        0;
    }

    const residentCart = this.cartService.cart.getResidentCart(residentId);
    const residentTotal = this.residentTotal;
    const depositTotal = residentCart?.deposit ?? 0;
    const residentBudget = this.resident.monthlyBudgetValue ?? 0;
    return (
      residentBudget -
      residentsOrderSum -
      residentTotal -
      parseFloat(depositTotal.toFixed(2))
    );
  }

  getBudgetText() {
    return `Hinterlegtes Budget: € ${this.resident.monthlyBudgetValue.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  moveToResidentPage(resident: Resident) {
    this.router.navigate([`/residents/${resident.id}`], {
      queryParams: {
        customerId: resident.customerId,
        departmentId: resident.departmentId,
      },
    });
  }
}
